import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonModal, ModalController } from '@ionic/angular';
import { NotifierService } from 'angular-notifier';
import { Visitor } from '../../models/visitor.model';
import { VisitorChild } from '../..//models/visitorChild';
import { LanguageService } from 'src/app/services/language.service';
import { VisitorService } from '../../services/visitor.service';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss'],
})
export class ConsentComponent implements OnInit {
   @ViewChild(IonModal) modal: IonModal;
  @ViewChild('canvas', { static: true }) signaturePadElement;
  @ViewChild('registerDoc')
  registerDoc!: ElementRef;
  @ViewChild('terms')
  terms!: ElementRef;
  @ViewChild('logo')
  logo!: ElementRef;
  @ViewChild('submitBtn')
  submitBtn!: ElementRef;
  @ViewChild('dateLabel')
  dateLabel!: ElementRef;
  language$ = this.languageService.language$;
  language: string;
  dateToday = new Date();
  areTermsRead: boolean = false;
  visitor: Visitor = new Visitor();
  isLoading = false;
  visitors: Array<VisitorChild> = [];
  visitorsFormJson: Array<VisitorChild> = [];
  allVisitors: Array<VisitorChild> = [];
  isShow = false;
  isChildFormVisible = false;
  childEdit: VisitorChild;
  errMsg = '';
  private sub: any;
  id: any;
  combinedData: Array<VisitorChild> = [];
  @ViewChild('marketingCheckbox', { static: false }) marketingCheckbox!: ElementRef;
  @ViewChild('termsCheckbox', { static: false }) termsCheckbox!: ElementRef;
  @ViewChild('scrollBtn ', { static: false }) divScrollToContent!: ElementRef;

  constructor(private elementRef: ElementRef,
    private router: Router,
    private languageService: LanguageService,
    private visitorService: VisitorService,
    private notifierService: NotifierService,
    private route : ActivatedRoute,
  )
    {
      this.sub = this.route
      .params
      .subscribe(params => {
        this.visitor = JSON.parse(params["visitor"]);
        this.visitorsFormJson = JSON.parse(params["visitorsFormJson"]);
        // this.visitors = JSON.parse(params["visitors"]);
        this.allVisitors.push(...this.visitorsFormJson);
        this.allVisitors.push(...this.visitors);
      });
    }

  pagePath: string;
  signaturePad: any;
  // isSignatured: boolean = false;
  ngOnInit() {

    this.language$.subscribe((lng) => (this.language = lng.toUpperCase()));
    this.pagePath = this.router.url;
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = 813;
    canvas.height = 242;
    if (this.signaturePad) {
      this.signaturePad.clear(); // Clear the pad on init
    }
  }

  goToPrivacy() {
  this.allVisitors = []; 
  this.router.navigate(['registration/app-text-privacyPolicy'], {
    queryParams: {
      returnTo: 'consent',
      visitor: JSON.stringify(this.visitor),
      visitorsFormJson: JSON.stringify(this.visitorsFormJson)
    }
  });
}

  resetNameControl() {
    this.visitor.fullName = '';
    this.visitor.phone = '';
    this.visitor.email = ''; 
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  clear() {
    this.signaturePad.clear();
    // this.isSignatured = false;
  }

  // setIsSignatured() {
  //   this.isSignatured = true;
  // }

  isCanvasBlank(): boolean {
    if (this.signaturePad) {
      return this.signaturePad.isEmpty() ? true : false;
    }
  }
  areFieldsPopulated(): boolean {
    return !!(
      // this.isSignatured &&
      this.areTermsRead
    );
  }
  validateAddVisitor() {
    const user = this.visitor;
    let errMsg: string;
    if (!user.fullName) {
      errMsg = 'Unesite ime roditelja / staratelja.';
    } else if (!user.phone) {
      errMsg = 'Unesite broj telefona.';
    } else {
      errMsg = '';
      return { isValid: true, errMsg };
    }
    return { isValid: false, errMsg };
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(
      this.signaturePadElement.nativeElement
    );
    this.signaturePad.clear();
    // mozemo dodatno smanjiti debljinu potpisa
    // this.signaturePad.minWidth = 1;
    // this.signaturePad.maxWidth = 1;
    this.signaturePad.penColor = 'rgb(56,128,255)';
  }
  
  async saveVisitor() {
    this.isLoading = true;
    const formValidation = this.validateAddVisitor();
    this.errMsg = formValidation.errMsg;
  
    if (!formValidation.isValid) return;
  
    const that = this;
    const div = this.registerDoc.nativeElement;
    const dateLabel = this.dateLabel.nativeElement;
    const marketingCheckbox = this.marketingCheckbox.nativeElement;
    const termsCheckbox = this.termsCheckbox.nativeElement;
    const divScrollToContent = this.divScrollToContent.nativeElement;
    const submitBtn = this.submitBtn.nativeElement;
    let img: any;
    let newImage: any;
    dateLabel.style.display = 'block';
    if(this.visitor.marketingMessage){
      marketingCheckbox.style.display = 'block';
    }
    termsCheckbox.style.display = 'block';
    submitBtn.style.visibility = 'hidden';
    divScrollToContent.style.visibility = 'hidden';

      domtoimage
        .toJpeg(div, { bgcolor: 'black'}, )
        .then(function(dataUrl) {
          img = new Image();
          img.src = dataUrl;
          newImage = img.src;
          img.onload = function() {
            const pdfWidth = img.width;
            const pdfHeight = img.height;

            // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
            let doc: jsPDF;
            if (pdfWidth > pdfHeight) {
              doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
            } else {
              doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
            }

            const width = doc.internal.pageSize.getWidth();
            const height = doc.internal.pageSize.getHeight();

            doc.addImage(newImage, 'JPG', 10, 10, width, height);
            // filename = 'mypdf_' + '.pdf';
            // doc.save(filename);
            //terms.style = 'max-height: 250px; color: white; overflow:auto; opacity: 0.5; width: 586px;'
            submitBtn.style = 'visibility: visible';
            divScrollToContent.style = 'visibility: visible';
            dateLabel.style = 'display: none';
            marketingCheckbox.style = 'display: none';
            termsCheckbox.style = 'display: none';
            //logo.style =  'top: 130px; left: -217px';
    
          that.visitorService
          .saveVisitor(
            that.visitor,
            that.allVisitors,
            doc.output('blob'),
            that.visitor.marketingMessage
          )
            .subscribe(
              () => {
                that.resetNameControl();
                that.isLoading = false;
                that.showSuccessAndRedirect();
              },
              (error) => {
                console.log('greska', error);
                that.showErrorAndRedirect(error);
              }
            );
      };
    });
  }
  
  showErrorAndRedirect(error) {
    this.notifierService.show({
      message: '' + JSON.stringify(error.error.title),
      type: 'warning',
    });
    this.isLoading = false;
    this.router.navigateByUrl('/registration/home');
  }

  showSuccessAndRedirect() {
    let message = '';
  if (this.language === 'SR') {
    message = 'Visit successfully registered!';
  } else {
    message = 'Poseta uspešno registrovana!';
  }
    this.notifierService.show({
      // eslint-disable-next-line object-shorthand
      message: message,
      type: 'success',
    });
    this.visitor = new Visitor();
    this.visitors = [];
    this.visitorsFormJson = [];
  
    this.areTermsRead = false;
    this.signaturePad.clear();
    this.router.navigateByUrl('/registration/home');
  }

  scrollToContent() {
    const target = document.getElementById('canvasContainerPortrait');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
